import ComponentName from '@Constant/componentName'

const crowd = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/landing.page',
    redirect: {
      name: ComponentName.landingPage.index
    },
    children: [
      {
        component: () => import('../../views/landing-page/index'),
        path: 'index',
        name: ComponentName.landingPage.index,
        auth: '*',
        meta: {
          title: '我的落地页'
        }
      }
    ]
  }
]

export default crowd
